import { map } from 'rxjs/operators'
import { IEditCertificationReferenceObject } from '../../../models/Recertification'
import { GET, POST, PUT } from '../../../module/services/fetch'
import { IFetchMassiveBody } from './constants'

export const fetchCertificationRequest = (payload: any) => {
  const { role, body, sortBy } = payload
  return POST(
    `recertification/v1/instances?role=${role}${
      sortBy && sortBy.length > 0
        ? `&sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? 'desc' : 'asc'
          }`
        : ''
    }`,
    body
  ).pipe(map((response: any) => response))
}

export const fetchCampaignRevisors = (payload: any) => {
  const { body, sortBy } = payload
  return POST(
    `recertification/instances/revisors${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? 'desc' : 'asc'
          }`
        : ''
    }`,
    body
  ).pipe(map((response: any) => response))
}

export const fetchCertificationInfo = (campaignId: string) => {
  return GET(`recertification/info?campaignId=${campaignId}`)
}

export const fetchSupervisorsAndRevisorsRequestCertificationReference = (
  request: any
) => {
  const req = {
    ...(request ? request : {}),
  }
  //w1 - project metro
  return POST('recertification/user/find', req).pipe(map((response: any) => response))
}

export const fetchUsersRequest = (request: any = {}) => {
  const req = request ? request : {}
  //w1 - project metro
  return POST('recertification/user/find', req).pipe(map((response: any) => response))
}

export const fetchBRRequest = (request: any = {}) => {
  const req = request ? request : {}
  return POST('businessRole/find', req).pipe(map((response: any) => response))
}

export const fetchApplicationsRequest = (request: any = {}) => {
  const req = request ? request : {}
  return POST('application/find', req).pipe(map((response: any) => response))
}

export const certificationItemsKeep = (payload: {
  body: {
    items: string[]
    note: string
  }
  actingAs?: string
}) =>
  POST(
    `recertification/v1/item/keep${
      payload.actingAs ? `?actingAs=${payload.actingAs}` : ''
    }`,
    payload.body
  )

export const certificationItemsRevoke = (payload: {
  body: {
    items: string[]
    note: string
  }
  actingAs?: string
}) =>
  POST(
    `recertification/v1/item/revoke${
      payload.actingAs ? `?actingAs=${payload.actingAs}` : ''
    }`,
    payload.body
  )

export const certificationItemsValidate = (payload: {
  body: {
    items: string[]
    note: string
  }
  actingAs?: string
}) =>
  POST(
    `recertification/v1/item/validate${
      payload.actingAs ? `?actingAs=${payload.actingAs}` : ''
    }`,
    payload.body
  )

export const fetchRevisorsRequest = (body: any) => {
  const req = body ? body : {}
    //w1 - project metro
  return POST('recertification/user/find', req).pipe(map((response: any) => response))
}

export const fetchEditCertificationInstance = (
  body: IEditCertificationReferenceObject
) => PUT('recertification/v1/instances', body)

export const fetchCloseCertification = ({
  recInstanceId,
  body,
}: {
  recInstanceId: string
  body: string
}) =>
  POST(
    `recertification/v1/instances/${recInstanceId}/close`,
    body,
    undefined,
    undefined,
    'application/json',
    'text/plain;charset=UTF-8'
  ).pipe(map((response: any) => response))

export const fetchSendCertificationReminder = (recInstanceId: string) =>
  POST(
    `recertification/v1/instances/${recInstanceId}/sendReminder`,
    undefined,
    undefined,
    'text/plain',
    'text/plain',
    'text/plain'
  ).pipe(map((response: any) => response))

export const fetchCloseCertificationItem = (itemId: string) =>
  POST(`recertification/v1/item/${itemId}/close`).pipe(
    map((response: any) => response)
  )

export const fetchUpdateRevisor = (itemIds: string[], revisorId: string) =>
  PUT(`recertification/v1/items?revisor=${revisorId}`, itemIds).pipe(
    map((response: any) => response)
  )
export const fetchUpdateAggregateOuRevisor = (
  body: {
    ouId: string
    campaignId: string
  }[],
  revisorId: string
) =>
  PUT(`recertification/aggregation/ou/items?revisor=${revisorId}`, body).pipe(
    map((response: any) => response)
  )
export const fetchUpdateAggregateUserRevisor = (
  body: {
    userCode: string
    campaignId: string
  }[],
  revisorId: string
) =>
  PUT(
    `recertification/aggregation/users/items?revisor=${revisorId}`,
    body
  ).pipe(map((response: any) => response))
export const fetchUpdateAggregateTechnicalUserRevisor = (
  body: {
    tuCode: string
    campaignId: string
  }[],
  revisorId: string
) =>
  PUT(
    `recertification/aggregation/technical-users/items?revisor=${revisorId}`,
    body
  ).pipe(map((response: any) => response))
export const fetchUpdateAggregateBrEntRevisor = (
  body: {
    brId?: string
    entitlemetId?: string
    identitySystemId: string
    campaignId: string
    businessRole?: boolean
  }[],
  revisorId: string
) =>
  PUT(
    `recertification/aggregation/entitlements/items?revisor=${revisorId}`,
    body
  ).pipe(map((response: any) => response))

export const fetchReOpenItem = (itemId: string) =>
  POST(`recertification/v1/item/${itemId}/open`).pipe(
    map((response: any) => response)
  )

export const fetchUserTabList = (payload: any) => {
  const { tmpUserBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/users/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'id'
              ? 'userCode'
              : sortBy[0].id === 'ou'
              ? 'ouName'
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    tmpUserBody
  ).pipe(map((response: any) => response))
}

export const fetchOUTabList = (payload: any) => {
  const { tmpOUBody, sortBy, actingAs } = payload
  const url = `recertification/aggregation/ou/find${
    actingAs ? `?actingAs=${actingAs}` : ``
  }${
    actingAs && sortBy && sortBy.length > 0
      ? `&`
      : sortBy && sortBy.length > 0
      ? `?`
      : ``
  }${
    sortBy && sortBy.length > 0
      ? `sortField=${
          sortBy[0].id === 'owner'
            ? 'ouOwner'
            : sortBy[0].id === 'name'
            ? 'ouName'
            : sortBy[0].id
        }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
      : ''
  }`
  return POST(url.trim(), tmpOUBody).pipe(map((response: any) => response))
}

export const fetchBRTabList = (payload: any) => {
  const { tmpBRBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/br/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'name'
              ? 'businessRoleName'
              : sortBy[0].id === 'description'
              ? 'businessRoleDescription'
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    tmpBRBody
  ).pipe(map((response: any) => response))
}

export const fetchEntitlementTabList = (payload: any) => {
  const { tmpEntitlementBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/entitlements/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? 'desc' : 'asc'
          }`
        : ''
    }`,
    tmpEntitlementBody
  ).pipe(map((response: any) => response))
}

export const fetchAccountTabList = (payload: any) => {
  const { tmpAccountBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/accounts/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? 'desc' : 'asc'
          }`
        : ''
    }`,
    tmpAccountBody
  ).pipe(map((response: any) => response))
}

export const fetchTechnicalUserTabList = (payload: any) => {
  const { tmpTechnicalUserBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/technical-users/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? 'desc' : 'asc'
          }`
        : ''
    }`,
    tmpTechnicalUserBody
  ).pipe(
    map((response: any) => {
      return response
    })
  )
}

export const fetchEntitlementsGivenUser = (payload: any) => {
  const { getEntitlementsGivenUserBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/entitlements/item/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'revisor' ? 'revisorFull' : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    getEntitlementsGivenUserBody
  ).pipe(map((response: any) => response))
}

export const fetchUsersGivenEntitlement = (payload: any) => {
  const { getUsersGivenEntitlementBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/users/item/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'ou'
              ? 'ouName'
              : sortBy[0].id === 'code'
              ? 'userCode'
              : sortBy[0].id === 'revisor'
              ? 'revisorFull'
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    getUsersGivenEntitlementBody
  ).pipe(map((response: any) => response))
}

export const fetchEnTitlementsGivenOu = (payload: any) => {
  const { getEntitlementsGivenOuBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/entitlements/item/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'revisor' ? 'revisorFull' : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    getEntitlementsGivenOuBody
  ).pipe(map((response: any) => response))
}

export const fetchEnTitlementsGivenBr = (payload: any) => {
  const { getEntitlementsGivenBrBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/entitlements/item/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'revisor' ? 'revisorFull' : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    getEntitlementsGivenBrBody
  ).pipe(map((response: any) => response))
}

export const fetchAccountsGivenUser = (payload: any) => {
  const { getAccountsGivenUserBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/accounts/item/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'user'
              ? 'userCode'
              : sortBy[0].id === 'application'
              ? 'targetName'
              : sortBy[0].id === 'applicationDescription'
              ? 'targetDescription'
              : sortBy[0].id === 'revisor'
              ? 'revisorFull'
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    getAccountsGivenUserBody
  ).pipe(map((response: any) => response))
}

export const fetchTechnicalUsersGivenEntitlement = (payload: any) => {
  const { getTechnicalUsersGivenEntitlementBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/technical-users/item/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'user'
              ? 'userCode'
              : sortBy[0].id === 'application'
              ? 'targetName'
              : sortBy[0].id === 'applicationDescription'
              ? 'targetDescription'
              : sortBy[0].id === 'revisor'
              ? 'revisorFull'
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    getTechnicalUsersGivenEntitlementBody
  ).pipe(map((response: any) => response))
}

export const fetchEntitlementsGivenTechnicalUser = (payload: any) => {
  const { getEntitlementsGivenTechnicalUserBody, sortBy, actingAs } = payload
  return POST(
    `recertification/aggregation/entitlements/item/find${
      actingAs ? `?actingAs=${actingAs}` : ``
    }${
      actingAs && sortBy && sortBy.length > 0
        ? `&`
        : sortBy && sortBy.length > 0
        ? `?`
        : ``
    }${
      sortBy && sortBy.length > 0
        ? `sortField=${
            sortBy[0].id === 'user'
              ? 'userCode'
              : sortBy[0].id === 'application'
              ? 'targetName'
              : sortBy[0].id === 'applicationDescription'
              ? 'targetDescription'
              : sortBy[0].id === 'revisor'
              ? 'revisorFull'
              : sortBy[0].id
          }&sortOrder=${sortBy[0].desc ? 'desc' : 'asc'}`
        : ''
    }`,
    getEntitlementsGivenTechnicalUserBody
  ).pipe(map((response: any) => response))
}

export const fetchMassiveOperation = (
  instanceId: string,
  endpoint: string,
  body: IFetchMassiveBody
) =>
  POST(`recertification/instances/${instanceId}/${endpoint}`, body).pipe(
    map((response: any) => response)
  )
